






















import vOpenMatch from 'components/openMatch/index.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    vOpenMatch
  }
})
export default class VHeader extends Vue {
  dialogVisible: boolean = false;
}
